<template>
  <div><a class="footer-cookie" @click="showModal()">Politique d'utilisation des cookies</a></div>
</template>

<script>
import CookiesModalContent from '@/components/CookiesModalContent'
export default {
  name: 'Footer',
  methods: {
    showModal () {
      this.$modal.show(
        CookiesModalContent,
        {},
        { width: '80%', height: 'auto', scrollable: true, name: 'total-cookie-modal' },
      )
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  background-color: #F5F7FA;
}
.footer-cookie {
  text-decoration: underline;
  cursor: pointer;
}
</style>